<template>
  <custom-dialog width="550px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
        <el-form-item :label="$t('info_dialog_ygxm')" prop="realName">
          <el-input v-model="form.realName" style="width:100%;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('info_dialog_lian_xi_dian_hua')" prop="mobile">
          <el-input v-model="form.mobile" style="width:100%;"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button size="small" type="warning" @click="confirm">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

// info_dialog_ygxm: 员工姓名// info_dialog_lian_xi_dian_hua: 联系电话// info_dialog_qtxyhmc: 请填写用户名称// info_dialog_qtxlxdh: 请填写联系电话

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        realName: '',
        mobile: '',
        // email: ''
      },
      userInfo: {}
    };
  },
  computed: {
    rules() {
      return {
        realName: {
          required: true,
          message: this.$t('info_dialog_qtxyhmc')
        },
        mobile: {
          required: true,
          message: this.$t('info_dialog_qtxlxdh')
        },
      };
    }
  },
  mounted() {
    this.mergeLanguage(null, 'portal_info_dialog');
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.userInfo = this.model.userInfo;
      this.$setFormatData(this.form, this.userInfo);
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.updateUserInfo();
      });
    },
    // 更新用户信息
    updateUserInfo: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.UserInfo, this.form)
          .then(() => {
            this.userInfo.realName = this.form.realName;
            this.userInfo.mobile = this.form.mobile;
            this.$store.commit('USERINFO', this.userInfo);
            this.$message({
              message: this.$t('com_handle_success'),
              type: 'success'
            });
            this.visible = false;
          })
          .catch(() => {});
      });
    }
  }
};
</script>

<style lang="scss"></style>
